import { uploadUrl } from "../../lib/assets";
import { getRelatedStories } from "../../data/stories";
import StoryContent from "./StoryContent";

/**
 * @param {{ story: import("../../data/stories").STORIES[0], onBack: () => void, onOpen: (id: string) => void }} props
 */
export default function StoryReader({ story, onBack, onOpen }) {
  const related = getRelatedStories(story.id);
  const coverSrc = uploadUrl(story.img);

  return (
    <article className="story-reader">
      <div
        className="story-reader__hero"
        style={{ backgroundImage: `url('${coverSrc}')` }}
      >
        <div className="story-reader__hero-scrim" />
        <div className="story-reader__hero-content">
          <h1 className="story-reader__title">{story.title}</h1>
          <div className="story-reader__byline">
            <span>CJ JAYAMAHA</span>
            <span aria-hidden="true">·</span>
            <span>{story.date}</span>
            {story.read ? (
              <>
                <span aria-hidden="true">·</span>
                <span>{story.read}</span>
              </>
            ) : null}
          </div>
        </div>
      </div>

      <div className="story-reader__back-wrap">
        <button type="button" className="story-reader__back" onClick={onBack}>
          ← ALL STORIES
        </button>
      </div>

      <StoryContent body={story.body} />

      <div className="story-reader__footer">
        {story.tags?.length ? (
          <div className="story-reader__tags">
            {story.tags.map((tag) => (
              <span key={tag} className="story-reader__tag">
                #{tag}
              </span>
            ))}
          </div>
        ) : null}

        <div className="story-reader__author">
          <div
            className="story-reader__author-avatar"
            style={{
              backgroundImage: `url('${uploadUrl("cjmeister-com-_DSC6660-Edit.jpg")}')`,
            }}
          />
          <div>
            <div className="story-reader__author-name">CJ Jayamaha</div>
            <p className="story-reader__author-bio">
              Photographer, storyteller, explorer. Builds products by day, chases
              stories the rest of the time.
            </p>
          </div>
        </div>
      </div>

      {related.length > 0 ? (
        <section className="story-reader__related">
          <div className="story-reader__related-heading">KEEP READING</div>
          <div className="story-reader__related-grid">
            {related.map((item) => (
              <button
                key={item.id}
                type="button"
                className="story-reader__related-card"
                onClick={() => onOpen(item.id)}
              >
                <div
                  className="story-reader__related-image"
                  style={{ backgroundImage: `url('${uploadUrl(item.img)}')` }}
                />
                <div className="story-reader__related-title">{item.title}</div>
              </button>
            ))}
          </div>
        </section>
      ) : null}
    </article>
  );
}
